import { TextField, type TextFieldProps } from "./TextField";

export interface FirstNameFieldProps extends Omit<TextFieldProps, "name"> {
  /** Por defecto `"firstName"`, que es como se llama en los contratos. */
  name?: string;
}

/**
 * El nombre de pila, separado de los apellidos.
 *
 * Mismo patrón que `FullNameField` —que sigue existiendo para los
 * formularios donde el nombre es una sola casilla— pero con el
 * `autoComplete="given-name"` que emparejan los navegadores y los
 * gestores de direcciones. Ese token es lo único que hace que el
 * autocompletado reparta bien un contacto guardado entre los dos campos;
 * con `name` en ambos, el navegador rellena el nombre completo dos veces.
 */
export function FirstNameField({ name = "firstName", ...rest }: FirstNameFieldProps) {
  return (
    <TextField
      label="Nombre"
      placeholder="María"
      autoComplete="given-name"
      autoCapitalize="words"
      {...rest}
      name={name}
    />
  );
}
